import {
  Image,
  useColorMode
} from '@chakra-ui/react';
import styled from 'styled-components';
import Logos from '../../images/logos';

/*
|--------------------------------------------------------------------------
| Styled Components
|--------------------------------------------------------------------------
*/

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 560px;
`;

const HeaderText = styled.h1`
  font-weight: 300;
  font-size: 1.1em;
  text-align: center;
  line-height: 1.4em;
`;

const BoldHeaderText = styled.span`
  font-weight: bold;
  display: block;
  margin-bottom: 16px;
`;

/*
|--------------------------------------------------------------------------
| Page Component
|--------------------------------------------------------------------------
*/

export default function UrlFetchErrorPage() {

  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <PageContainer>
				<Image
					style={{ marginBottom: '24px', marginTop: '24px' }}
					w="auto"
					h="45px"
					src={Logos[colorMode]['ss']}
					alt="SharpSports"
				/>
      <HeaderText>
        <BoldHeaderText>This bet is not available</BoldHeaderText>
      </HeaderText>
    </PageContainer>
  );
}